import { RouteConfig } from "@abaco/web-common/src/app";

const routes: RouteConfig[] = [
    {
        name: "print-view",
        path: "/print-plot",
        component: () => import("./components/PrintView.vue"),
        props: true
    },
]

export default routes;